/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_LanguageInputs */

const en_target_language = /** @type {(inputs: Target_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Language`)
};

const fr_target_language = /** @type {(inputs: Target_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue cible`)
};

const de_target_language = /** @type {(inputs: Target_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielsprache`)
};

const it_target_language = /** @type {(inputs: Target_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua di destinazione`)
};

const ru_target_language = /** @type {(inputs: Target_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевой язык`)
};

const es_target_language = /** @type {(inputs: Target_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengua de llegada`)
};

const zh_cn2_target_language = /** @type {(inputs: Target_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标语言`)
};

const ja_target_language = /** @type {(inputs: Target_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲット言語`)
};

const hi_target_language = /** @type {(inputs: Target_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य भाषा`)
};

const pt_pt2_target_language = /** @type {(inputs: Target_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Língua de destino`)
};

/**
* | output |
* | --- |
* | "Target Language" |
*
* @param {Target_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_language = /** @type {((inputs?: Target_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_target_language(inputs)
	if (locale === "de") return de_target_language(inputs)
	if (locale === "it") return it_target_language(inputs)
	if (locale === "ru") return ru_target_language(inputs)
	if (locale === "es") return es_target_language(inputs)
	if (locale === "zh-CN") return zh_cn2_target_language(inputs)
	if (locale === "ja") return ja_target_language(inputs)
	if (locale === "hi") return hi_target_language(inputs)
	if (locale === "pt-PT") return pt_pt2_target_language(inputs)
	return en_target_language(inputs)
});